import type { ReactNode, ReactElement } from 'react';
import * as React from 'react';
import { Button } from 'react-aria-components';
import { SlideoutMenu } from '@/components/_untitled/application/slideout-menus/slideout-menu';
import type { ComponentWithClose } from '@/components/ui/ButtonHelpers';

interface SlideoutTriggerProps {
  content: ReactElement<ComponentWithClose>;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const SlideoutTrigger = ({ content, children, className, onClick }: SlideoutTriggerProps) => {
  return (
    <SlideoutMenu.Trigger>
      <Button className={className} onPress={onClick}>
        {children}
      </Button>
      <SlideoutMenu>
        {({ close }) => (
          React.cloneElement(content, { onClose: close })
        )}
      </SlideoutMenu>
    </SlideoutMenu.Trigger>
  );
};